// @ts-ignore
/* eslint-disable */

import requestData from '@/utils/http'

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser() {
  return requestData<API.CurrentUser>('/admins/current')
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams) {
  return requestData<API.LoginResult>('/auth/login', { method: 'POST', data: body })
}
